import type {
    BookingServiceWindow,
    BookingServiceWindowInput,
    BookingWorkHours,
} from 'owa-graph-schema';
import mapToBookingWorkHoursInput from './mapToBookingWorkHoursInput';

const mapToBookingServiceWindowInput = (
    bookingServiceWindows: BookingServiceWindow[]
): BookingServiceWindowInput[] => {
    const modifiedServiceWindows: BookingServiceWindowInput[] = bookingServiceWindows.map(
        serviceWindow => {
            const { startDate, endDate, bookableHours } = serviceWindow;
            return {
                startDate,
                endDate,
                bookableHours: mapToBookingWorkHoursInput(bookableHours as BookingWorkHours[]),
            };
        }
    );
    return modifiedServiceWindows;
};

export default mapToBookingServiceWindowInput;
